export interface Options {
  [key: string]: string[];
}

export const enum SelfAssessmentOptions {
  Sometimes = 'Sometimes',
  MostOfTheTime = 'Most of the time',
  AllTheTime = 'All the time',
}
